import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {

  ngOnInit(): void {
    this.loadGoogleMapsScript();
  }

  private loadGoogleMapsScript(): void {
    if ((window as any).google?.maps) return;

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsAPIKey}&libraries=places`;
    script.async = true;
    document.body.appendChild(script);
  }
}
